__turbopack_context__.v({
  "card": "CornerNotification-module-scss-module__DKwaKG__card",
  "card-content": "CornerNotification-module-scss-module__DKwaKG__card-content",
  "card-cta": "CornerNotification-module-scss-module__DKwaKG__card-cta",
  "card-description": "CornerNotification-module-scss-module__DKwaKG__card-description",
  "card-header": "CornerNotification-module-scss-module__DKwaKG__card-header",
  "card-title": "CornerNotification-module-scss-module__DKwaKG__card-title",
  "close-button": "CornerNotification-module-scss-module__DKwaKG__close-button",
  "is-in-view": "CornerNotification-module-scss-module__DKwaKG__is-in-view",
  "wrapper": "CornerNotification-module-scss-module__DKwaKG__wrapper",
});
